<div class="container wow fadeIn top-buffer">
    <div class="container my-5">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <b-card title="Developers" type="secondary" shadow>
                    <b-card-text>
                        <p class="text-muted">Everything you need to connect to the Umbai API.</p>

                        <b-tabs pills fill nav-class="developer-tabs" active-nav-item-class="font-weight-bold">
                            <b-tab title="Test" active>
                                <credentials environment="test"></credentials>
                            </b-tab>
                            <b-tab title="Live" lazy>
                                <credentials environment="live"></credentials>
                            </b-tab>
                        </b-tabs>
                    </b-card-text>
                </b-card>
            </div>
        </div>
    </div>
</div>
